import axios from '../index';

export const requestReportCreate = ({ data }) => axios.post(`/fhir/Observation/`, data);

export const requestReportsList = ({
  performer,
  type,
  searchValue,
  desc,
  sort,
  count,
  pagesOffset,
}) =>
  axios.get('/fhir/Observation', {
    params: {
      performer,
      code: 'patient_report',
      status: 'final,preliminary,registered',
      _count: count,
      _getpagesoffset: pagesOffset,
      [`_sort${desc ? ':desc' : ':asc'}`]: sort,
      ...(searchValue && { [type]: searchValue }),
    },
  });

export const requestRegisteredReportsList = ({
  performer,
  type,
  searchValue,
  desc,
  sort,
  count,
  pagesOffset,
}) =>
  axios.get('/fhir/Observation', {
    params: {
      performer,
      code: 'patient_report',
      status: 'registered',
      _count: count,
      _getpagesoffset: pagesOffset,
      [`_sort${desc ? ':desc' : ':asc'}`]: sort,
      ...(searchValue && { [type]: searchValue }),
    },
  });

export const requestReports = ({ patientId, ...rest }) =>
  axios.get(`/fhir/Observation`, {
    params: {
      subject: patientId,
      _count: 10,
      status: 'final,preliminary,registered',
      _elements: 'effectiveDateTime,status,component',
      _sort: '-date',
      ...rest,
    },
  });

export const requestObservationUpdate = ({ id, data }) =>
  axios.put(`/fhir/Observation/${id}`, data);

export const requestAlerts = ({ count, pagesOffset, sort, desc, type, searchValue, performer }) =>
  axios.get(`/fhir/Observation`, {
    params: {
      performer,
      status: 'final,preliminary',
      _total: 'accurate',
      _count: count,
      _getpagesoffset: pagesOffset,
      [`_sort${desc ? ':desc' : ':asc'}`]: sort,
      ...(searchValue && { [type]: searchValue }),
    },
  });
